<template>
	<div>
		<banner :pics="pics" />
		<mainDiv />
	</div>
</template>

<script>
	import banner from '@/components/index/banner'
	import mainDiv from '@/components/index/main'

	import axios from '@/axios/'

	export default {
		components: {
			banner,
			mainDiv,
		},
		data() {
			return {
				pics: [], //轮播图片s
			}
		},
		async created() {
			this.$emit('headerCur',0);
			try {
				let {data} = await axios('/index/banners');
				if (data.code == 200) {
					this.pics = data.data;
				}
			} catch (e) {
				//
			}
		},
	}
</script>
